// removed by extract-text-webpack-plugin
module.exports = {"Menu":"_2mfqpE6whnxNAs2z2Usn4c","Item":"_2RFXvKcstoTSZtu0Q1icn2","label":"p7n0c4X9nq1XARYyOq0Kb","sub-label":"_1w04Wr2W471WmdMWJ6QThj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlusWidget/PlusWidgetMenu/PlusWidgetMenu.css
// module id = 541
// module chunks = 0